var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect, _rect2, _rect3, _path19, _rect4, _polygon, _path20, _path21, _polygon2, _rect5, _path22, _path23, _rect6, _rect7, _path24, _rect8, _path25, _rect9, _path26, _polygon3, _path27, _path28, _path29, _rect10, _polygon4, _rect11;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 616 158",
    style: {
      enableBackground: "new 0 0 616 158"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n\t.st12{fill:url(#SVGID_13_);}\n\t.st13{fill:url(#SVGID_14_);}\n\t.st14{fill:url(#SVGID_15_);}\n\t.st15{fill:url(#SVGID_16_);}\n\t.st16{fill:url(#SVGID_17_);}\n\t.st17{fill:url(#SVGID_18_);}\n\t.st18{fill:url(#SVGID_19_);}\n\t.st19{fill:url(#SVGID_20_);}\n\t.st20{fill:url(#SVGID_21_);}\n\t.st21{fill:url(#SVGID_22_);}\n\t.st22{fill:url(#SVGID_23_);}\n\t.st23{fill:url(#SVGID_24_);}\n\t.st24{fill:url(#SVGID_25_);}\n\t.st25{fill:url(#SVGID_26_);}\n\t.st26{fill:url(#SVGID_27_);}\n\t.st27{fill:url(#SVGID_28_);}\n\t.st28{fill:url(#SVGID_29_);}\n\t.st29{fill:url(#SVGID_30_);}\n\t.st30{fill:url(#SVGID_31_);}\n\t.st31{fill:url(#SVGID_32_);}\n\t.st32{fill:url(#SVGID_33_);}\n\t.st33{fill:url(#SVGID_34_);}\n\t.st34{fill:url(#SVGID_35_);}\n\t.st35{fill:url(#SVGID_36_);}\n\t.st36{fill:url(#SVGID_37_);}\n\t.st37{fill:url(#SVGID_38_);}\n\t.st38{fill:url(#SVGID_39_);}\n\t.st39{fill:url(#SVGID_40_);}\n\t.st40{fill:url(#SVGID_41_);}\n\t.st41{fill:url(#SVGID_42_);}\n\t.st42{fill:url(#SVGID_43_);}\n\t.st43{fill:url(#SVGID_44_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.2429,
    y1: 15.4489,
    x2: 175.2429,
    y2: 170.8792
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.8,38.6c-1.5-2.6-3.5-3.9-6.6-3.9c-3.3,0-6.9,2.2-6.9,5.9c0,3.2,3.2,4.9,5.7,5.9l3,1.1 c5.8,2.3,10.2,5.5,10.2,12.4c0,7.5-5.8,12.8-13.2,12.8c-6.7,0-11.9-4.9-12.7-11.5l5.2-1.1c-0.1,4.5,3.6,7.8,8,7.8 c4.4,0,7.6-3.7,7.6-8c0-4.4-3.6-6.3-7.1-7.8l-2.8-1.2c-4.7-2-9-4.7-9-10.4c0-6.7,5.9-10.7,12.1-10.7c4.6,0,8.4,2.2,10.6,6.2 L182.8,38.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.8034,
    y1: 15.4489,
    x2: 215.8034,
    y2: 170.8792
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.4,51.4c0,12.2-9.7,21.5-21.6,21.5c-11.9,0-21.6-9.2-21.6-21.5c0-11.8,9.8-21.5,21.6-21.5 C227.6,29.9,237.4,39.6,237.4,51.4z M232.3,51.4c0-9.1-6.8-16.7-16.5-16.7c-9.7,0-16.5,7.6-16.5,16.7c0,9.4,7.5,16.7,16.5,16.7 C224.7,68.1,232.3,60.8,232.3,51.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.9999,
    y1: 15.449,
    x2: 264.9999,
    y2: 170.8791
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M252.6,44.8h-0.1L247.7,72h-5.3l8.4-43L265,61.5L279.2,29l8.4,43h-5.3l-4.8-27.2h-0.1L265,72.9L252.6,44.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.1425,
    y1: 15.4489,
    x2: 314.1425,
    y2: 170.8792
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M335.7,51.4c0,12.2-9.7,21.5-21.6,21.5c-11.9,0-21.6-9.2-21.6-21.5c0-11.8,9.8-21.5,21.6-21.5 S335.7,39.6,335.7,51.4z M330.6,51.4c0-9.1-6.8-16.7-16.5-16.7c-9.7,0-16.5,7.6-16.5,16.7c0,9.4,7.5,16.7,16.5,16.7 C323.1,68.1,330.6,60.8,330.6,51.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.7584,
    y1: 15.4489,
    x2: 354.7584,
    y2: 170.8792
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M362.3,38.6c-1.5-2.6-3.5-3.9-6.6-3.9c-3.3,0-6.9,2.2-6.9,5.9c0,3.2,3.2,4.9,5.7,5.9l3,1.1 c5.9,2.3,10.2,5.5,10.2,12.4c0,7.5-5.8,12.8-13.2,12.8c-6.7,0-11.9-4.9-12.7-11.5l5.2-1.1c-0.1,4.5,3.6,7.8,8,7.8 c4.4,0,7.6-3.7,7.6-8c0-4.4-3.6-6.3-7.1-7.8l-2.8-1.2c-4.7-2-9-4.7-9-10.4c0-6.7,5.9-10.7,12.1-10.7c4.6,0,8.4,2.2,10.6,6.2 L362.3,38.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.7356,
    y1: 15.4493,
    x2: 175.7356,
    y2: 170.8785
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M169.6,127.7h-5.1V86.4h5.9c12.7,0,16.6,4.4,16.6,11.9c0,8.7-6.6,12-14.4,12h-3V127.7z M169.6,105.8h1.6 c5.2,0,10.9-1,10.9-7.5c0-6.5-6.1-7.2-11.2-7.2h-1.4V105.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.6308,
    y1: 15.4493,
    x2: 207.6308,
    y2: 170.8785
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.5,127.7h-6.2l-12.1-17.4H200v17.4h-5.1V86.4h6.2c3.7,0,7.6,0.1,10.9,1.9c3.4,2,5.4,5.9,5.4,9.8 c0,5.9-3.9,10.8-9.9,11.5L220.5,127.7z M200,106h1.6c5.2,0,10.9-1,10.9-7.5c0-6.5-6.1-7.4-11.2-7.4H200V106z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.4698,
    y1: 15.4486,
    x2: 246.4698,
    y2: 170.8788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M268.1,107c0,12.2-9.7,21.5-21.6,21.5c-11.9,0-21.6-9.2-21.6-21.5c0-11.8,9.8-21.5,21.6-21.5 C258.3,85.6,268.1,95.2,268.1,107z M262.9,107c0-9.1-6.8-16.7-16.5-16.7c-9.7,0-16.5,7.6-16.5,16.7c0,9.4,7.5,16.7,16.5,16.7 C255.4,123.7,262.9,116.5,262.9,107z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.6569,
    y1: 15.4493,
    x2: 282.6569,
    y2: 170.8785
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M285.2,127.7h-5.1V91.1h-9.8v-4.7H295v4.7h-9.8V127.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.2722,
    y1: 15.4491,
    x2: 313.2722,
    y2: 170.8786
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M303.8,117.3l-4.7,10.3h-5.5l19.7-43l19.7,43h-5.5l-4.7-10.3H303.8z M313.3,96l-7.3,16.7h14.7L313.3,96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.9611,
    y1: 15.4486,
    x2: 355.9611,
    y2: 170.8788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M376.1,106.9v1.6c0,11.3-8,20-19.5,20c-11.5,0-20.8-10-20.8-21.4c0-11.9,9.5-21.6,21.4-21.6 c6.4,0,12.7,2.9,16.8,8l-3.6,3.4c-3-4-7.9-6.7-13-6.7c-9.2,0-16.5,7.5-16.5,16.7c0,8.6,7.1,16.8,16,16.8 c6.4,0,13.3-5.5,13.5-12.2h-10.7v-4.7H376.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.1911,
    y1: 15.4486,
    x2: 403.1911,
    y2: 170.8788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M424.8,107c0,12.2-9.7,21.5-21.6,21.5c-11.9,0-21.6-9.2-21.6-21.5c0-11.8,9.8-21.5,21.6-21.5 C415,85.6,424.8,95.2,424.8,107z M419.6,107c0-9.1-6.8-16.7-16.5-16.7c-9.7,0-16.5,7.6-16.5,16.7c0,9.4,7.5,16.7,16.5,16.7 C412.1,123.7,419.6,116.5,419.6,107z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 450.5843,
    y1: 15.4488,
    x2: 450.5843,
    y2: 170.8788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M432.5,84.5l30.9,32.4V86.4h5.1v42.9l-30.9-32.4v30.7h-5.1V84.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 481.6326,
    y1: 15.4493,
    x2: 481.6326,
    y2: 170.8785
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M484.2,127.7h-5.1V86.4h5.1V127.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 505.9591,
    y1: 15.4486,
    x2: 505.9591,
    y2: 170.8788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M513.5,94.3c-1.5-2.6-3.5-3.9-6.6-3.9c-3.3,0-6.9,2.2-6.9,5.8c0,3.2,3.2,4.9,5.7,5.9l3,1.1 c5.9,2.3,10.2,5.5,10.2,12.4c0,7.5-5.8,12.8-13.2,12.8c-6.7,0-11.9-4.9-12.7-11.5l5.2-1.1c-0.1,4.5,3.6,7.8,8,7.8 c4.4,0,7.6-3.7,7.6-8c0-4.4-3.6-6.3-7.1-7.8l-2.8-1.2c-4.7-2-9-4.7-9-10.4c0-6.7,5.9-10.7,12.1-10.7c4.6,0,8.4,2.2,10.6,6.2 L513.5,94.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 535.2595,
    y1: 15.4493,
    x2: 535.2595,
    y2: 170.8785
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M537.8,127.7h-5.1V91.1h-9.8v-4.7h24.7v4.7h-9.8V127.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 565.8719,
    y1: 15.4491,
    x2: 565.8719,
    y2: 170.8786
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M556.4,117.3l-4.7,10.3h-5.5l19.7-43l19.7,43H580l-4.7-10.3H556.4z M565.9,96l-7.3,16.7h14.7L565.9,96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 603.043,
    y1: 15.4486,
    x2: 603.043,
    y2: 170.8788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M610.6,94.3c-1.5-2.6-3.5-3.9-6.6-3.9c-3.3,0-6.9,2.2-6.9,5.8c0,3.2,3.2,4.9,5.7,5.9l3,1.1 c5.9,2.3,10.2,5.5,10.2,12.4c0,7.5-5.8,12.8-13.2,12.8c-6.7,0-11.9-4.9-12.7-11.5l5.2-1.1c-0.1,4.5,3.6,7.8,8,7.8s7.6-3.7,7.6-8 c0-4.4-3.6-6.3-7.1-7.8l-2.8-1.2c-4.7-2-9-4.7-9-10.4c0-6.7,5.9-10.7,12.1-10.7c4.6,0,8.4,2.2,10.6,6.2L610.6,94.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.9647,
    y1: 15.449,
    x2: 136.9647,
    y2: 170.8789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394173,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567904,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    style: {
      stopColor: "#8D7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 135.6,
    y: -0.4,
    className: "st18",
    width: 2.6,
    height: 158
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.676,
    y1: -4.0885,
    x2: 19.676,
    y2: 161.4222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.3,
    y: 28.8,
    className: "st19",
    width: 39.9,
    height: 3.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.7178,
    y1: -4.0885,
    x2: 5.7178,
    y2: 161.4222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.3,
    y: 21.2,
    className: "st20",
    width: 12,
    height: 3.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.3751,
    y1: -4.0874,
    x2: 63.3751,
    y2: 161.4194
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M61.5,89.5h-22v3.9h22c10.2,0,19.6-4.7,25.8-12.9l-3.1-2.3C78.7,85.4,70.4,89.5,61.5,89.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.1771,
    y1: -4.0882,
    x2: 9.1771,
    y2: 161.4198
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.2,
    y: 128,
    className: "st22",
    width: 3.9,
    height: 28.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.1745,
    y1: -4.0875,
    x2: 19.1745,
    y2: 161.4197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "7.2,89.5 7.2,119.6 11.1,119.6 11.1,93.4 31.1,93.4 31.1,89.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.8262,
    y1: -4.0878,
    x2: 69.8262,
    y2: 161.419
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M48,28.8v3.9h13.5C73.2,32.7,83.8,40,88,51l3.6-1.4c-4.8-12.4-16.9-20.8-30.2-20.8H48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.8642,
    y1: -4.0879,
    x2: 90.8642,
    y2: 161.4199
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M89.8,58.6c0.1,0.8,0.1,1.7,0.1,2.5c0,3.5-0.6,7-1.9,10.3l3.6,1.4c1.4-3.7,2.2-7.6,2.2-11.7 c0-0.9,0-1.9-0.1-2.9L89.8,58.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.3967,
    y1: -4.0883,
    x2: 19.3967,
    y2: 161.4204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "-0.3,82 -0.3,96.6 3.6,96.6 3.6,85.9 39.1,85.9 39.1,82  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.6578,
    y1: -4.0884,
    x2: 1.6578,
    y2: 161.4204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -0.3,
    y: 105,
    className: "st27",
    width: 3.9,
    height: 51.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.5481,
    y1: -4.088,
    x2: 77.5481,
    y2: 161.4194
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M73,43.7c5.8,3.9,9.3,10.4,9.3,17.4c0,8.6-5.4,16.5-13.5,19.6l1.4,3.6c9.6-3.6,16-13,16-23.2 c0-8.3-4.1-16-11.1-20.6L73,43.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.667,
    y1: -4.0893,
    x2: 41.667,
    y2: 161.4234
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M16.4,36.3v3.9h45c1.6,0,3.1,0.2,4.6,0.5l0.9-3.8c-1.8-0.4-3.6-0.6-5.5-0.6H16.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.8859,
    y1: -4.0886,
    x2: 3.8859,
    y2: 161.422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -0.3,
    y: 36.3,
    className: "st30",
    width: 8.4,
    height: 3.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.3995,
    y1: -4.0896,
    x2: 54.3995,
    y2: 161.421
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4,
    y: 82,
    className: "st31",
    width: 13.9,
    height: 3.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.2621,
    y1: -4.0881,
    x2: 84.2621,
    y2: 161.4206
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M67.4,25.6c16.3,2.7,28.5,16.1,29.9,32.5l3.9-0.3c-1.5-18.2-15.1-33-33.1-36L67.4,25.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.7257,
    y1: -4.0872,
    x2: 39.7257,
    y2: 161.4166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 21.2,
    className: "st33",
    width: 39.3,
    height: 3.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.0143,
    y1: -4.0876,
    x2: 98.0143,
    y2: 161.4191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M95.1,73.7l3.7,1.4c1-2.7,1.8-5.6,2.2-8.5L97.1,66C96.7,68.6,96,71.2,95.1,73.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.6928,
    y1: -4.088,
    x2: 16.6928,
    y2: 161.4201
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7,
    y: 133.5,
    className: "st35",
    width: 3.9,
    height: 23.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.8682,
    y1: -4.0873,
    x2: 71.8682,
    y2: 161.4191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M61.5,97H48.9v3.9h12.5c13.5,0,25.9-6.8,33.3-18.1l-3.3-2.1C84.9,90.9,73.6,97,61.5,97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.6655,
    y1: -4.0877,
    x2: 27.6655,
    y2: 161.4198
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "14.7,97 14.7,125.2 18.6,125.2 18.6,100.9 40.6,100.9 40.6,97  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.4223,
    y1: -4.0873,
    x2: 106.4223,
    y2: 161.4191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M104,52.4c0.6,2.8,0.9,5.8,0.9,8.7c0,1.5-0.1,3.1-0.2,4.6l3.9,0.4c0.2-1.6,0.3-3.3,0.3-5 c0-3.2-0.3-6.4-0.9-9.5L104,52.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.0017,
    y1: -4.0874,
    x2: 88.0017,
    y2: 161.4193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M69.2,103.9l0.7,3.8c17.4-3.1,32-16.1,37-33.1l-3.7-1.1C98.5,89.1,85.1,101,69.2,103.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.1954,
    y1: -4.0878,
    x2: 85.1954,
    y2: 161.4195
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M65,17.8c16.4,1.3,30.5,11.7,36.7,27l3.6-1.5c-6.8-16.7-22.1-27.9-40-29.4L65,17.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.2098,
    y1: -4.0882,
    x2: 24.2098,
    y2: 161.4198
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3,
    y: 128,
    className: "st41",
    width: 3.9,
    height: 28.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.7262,
    y1: -4.088,
    x2: 41.7262,
    y2: 161.4196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03913559,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08506669,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E20613"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "22.3,104.5 22.3,119.6 26.2,119.6 26.2,108.4 61.2,108.4 61.2,104.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.2935,
    y1: 754.3642,
    x2: 53.6545,
    y2: 754.3642,
    gradientTransform: "matrix(1 0 0 -1 0 770)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0391356,
    style: {
      stopColor: "#DCD3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0850667,
    style: {
      stopColor: "#BAB5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#A09D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#7E7E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#E72C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E93E3A"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -0.2,
    y: 13.7,
    className: "st43",
    width: 53.9,
    height: 3.8
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.478faae6.svg";
export { ForwardRef as ReactComponent };